import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class VersionsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "versions", `/api/v1/versions`);
  }
}
